const SatcomStateEnum = Object.freeze({
  DISABLED: 1,
  MISCONFIGURED: 2,
  CONNECTED: 3,
  TRANSMITTED: 4
});

const SatcomNetworkEnum = Object.freeze({
  IRIDIUM: 1
});

export { SatcomStateEnum, SatcomNetworkEnum };
